import { render, staticRenderFns } from "./WellElecControllRecordModal.vue?vue&type=template&id=ddaaeb66&scoped=true"
import script from "./WellElecControllRecordModal.vue?vue&type=script&lang=js"
export * from "./WellElecControllRecordModal.vue?vue&type=script&lang=js"
import style0 from "./WellElecControllRecordModal.vue?vue&type=style&index=0&id=ddaaeb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaaeb66",
  null
  
)

export default component.exports